import styles from "./InUseDecoration.module.css";

export const InUseDecoration = ({ count }: { count: number }) => (
  <span className={styles.decoration}>{count}</span>
);
